/**
 * Set `deviceId` to PAS
 * @param  {deviceId} string
 */
export const setDeviceId = deviceId => window.iapiConf
    ? window.iapiSetDeviceId(encodeURIComponent(deviceId))
    : console.error('Set DeviceId failed. Pas is not ready.');
